import axiosInstance from './axios';
import {
  SiteSocial,
  SiteSocialsResponse,
  SiteSocialParams,
  CreateSiteSocialRequest,
} from 'types/siteSocial';

export const siteSocialsService = {
  getSiteSocials: async (params: SiteSocialParams): Promise<SiteSocialsResponse> => {
    const response = await axiosInstance.get<SiteSocialsResponse>('/admin/site-socials', {
      params,
    });
    return response.data;
  },

  createSiteSocial: async (data: CreateSiteSocialRequest): Promise<any> => {
    const formData = new FormData();
    formData.append('siteId', data.siteId.toString());
    formData.append('socialLink', data.socialLink);
    if (data.name) {
      formData.append('name', data.name);
    }
    formData.append('sortOrder', data.sortOrder.toString());
    if (data.imageUrl) {
      formData.append('imageUrl', data.imageUrl);
    }
    if (data.image) {
      formData.append('image', data.image);
    }

    const response = await axiosInstance.post('/admin/site-socials', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  updateSiteSocial: async (id: string, data: Partial<CreateSiteSocialRequest>): Promise<any> => {
    const response = await axiosInstance.patch(`/admin/site-socials/${id}`, data);
    return response.data;
  },

  deleteSiteSocial: async (id: string): Promise<any> => {
    const response = await axiosInstance.delete(`/admin/site-socials/${id}`);
    return response.data;
  },

  updateSocialImage: async (id: string, icon: File): Promise<any> => {
    const formData = new FormData();
    // Assuming the backend expects "image" field based on the refined instructions
    formData.append('image', icon);

    const response = await axiosInstance.post(`/admin/site-socials/${id}/image`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },
};
